import { createCustomEnum } from "./customEnum";

const TerminalFileBuildOptionTypes = createCustomEnum({
	TsysStageOnlyVar: {
		name: "tsys_stage_only_var",
		value: "tsys_stage_only_var",
		displayName: "TSYS Stage Only Var",
	},
	TsysSummit: {
		name: "tsys_summit",
		value: "tsys_summit",
		displayName: "TSYS Summit",
	},
	TsysTransit: {
		name: "tsys_transit",
		value: "tsys_transit",
		displayName: "TSYS Transit",
	},
	Other: {
		name: "other",
		value: "other",
		displayName: "Other",
	},
});

export default TerminalFileBuildOptionTypes;
